import { convertNumberDecimal, formatDateTime, transitionDecimalDigitsToFormatNumber } from "../../utils";
import {useFormatSetting,useCompanySettings } from "../../hooks/useCompanySettings";
import {TOOL_TEMPLATE,LIST_OF_DATA_STRING, POSITIVE_NUMBER_FORMAT} from "../../constant/common";
import PriceUpDown from "../ui/PriceUpDown";
import Icon from "../ui/Icon";
import {ConvertToArabicValue} from "../ui/NumberToArabic";
import i18n from "@euroland/libs/locale/i18n";
import { number } from "@euroland/format-number";
import { useSelectedInstrumentTimeZone } from "../../hooks/useInstruments";


// Exact|Hundreds|Thousands|Millions | Billions
const formatValue = (val, opt)=> {
    if(opt === 'Exact') return val;
    if (opt === 'Hundreds') return val / 100;
    if (opt === 'Thousands') return val / 1000;
    if (opt === 'Millions') return val / 1000000;
    if (opt === 'Billions') return val / 1000000000;
    return val;
  }

let isLongDate = true;

const MarketCapShare = (value,item)=> {
    const format = useFormatSetting();
    const settings = useCompanySettings();
    const { selectedInstrumentTimeZone } = useSelectedInstrumentTimeZone();
    const { marketCap, numberOfShare} = settings;
    const noValue = value === undefined || value === null;
      if (item) {
        if (item === 'marketCap') {
            let val = !noValue ? convertNumberDecimal(formatValue(value, marketCap),{decimalDigits: 0}) : i18n.translate('notDataAvailable');
          return val;
        }
        if (item === 'noShares') {
           let val = !noValue ? convertNumberDecimal(formatValue(value, numberOfShare),{decimalDigits: 0}) : i18n.translate('notDataAvailable');
          return val;
        }
        if (item === 'volume') {
          let intVal = formatValue(value, 'Exact');
          return value === null || value === undefined ? i18n.translate('notDataAvailable') : number(intVal, transitionDecimalDigitsToFormatNumber(0));
          // return parseInt(intVal) ? parseInt(intVal) : i18n.translate('notDataAvailable') ;
        }
        if (item === 'lastUpdatedDate') {
          let timeVal = formatDateTime(value, {...settings, timezone: selectedInstrumentTimeZone}, isLongDate);
          return timeVal ? timeVal : i18n.translate('notDataAvailable');
        } else {
            let val;
            if (LIST_OF_DATA_STRING[item] === item) {
                   val = value ? value : i18n.translate('notDataAvailable');
            } else if (item === undefined || value === undefined || value === null || item === null) {
                val = i18n.translate('notDataAvailable');
            } else {
                val = convertNumberDecimal(value, format) ? convertNumberDecimal(value, format) : i18n.translate('notDataAvailable');
              }
            return val;
        }
      }
      return value;
}
const checkType = (val)=> {
    const type = ["changePercentage", "change", "yTD", "percent52W"];
    return type.find((a) => val === a.replace("-", ""));
  }

const TableBodyDataFn = (instruments,item, body, align,template)=> {
    const format = useFormatSetting();
    let data = MarketCapShare(instruments[item],item).toString();
    // let data = ConvertToArabicValue(MarketCapShare(instruments[item],item).toString(),format);
    let child = data ? data : "";
    if (checkType(item)) {
      const iconClass = "arrow_up";
      const value = number(instruments[item], undefined, {
        positiveFormatPattern: format?.positiveNumberFormat || POSITIVE_NUMBER_FORMAT,
      });
      const priceStatus = instruments[item] > 0 ? 1 : instruments[item] < 0 ? -1 : 0;
      let ariaLabel;
      if (priceStatus === 1) {
        ariaLabel = i18n.translate("priceUpLabel");
      } else if (priceStatus === -1) {
        ariaLabel = i18n.translate("priceDownLabel");
      }
      child = (
        <PriceUpDown
          status={priceStatus}
          children={
            <>
              {template === TOOL_TEMPLATE.quadrata && (
                <>
                  <Icon ariaLabel={ariaLabel} name={iconClass} className={iconClass} role="img" />
                </>
              )}
              <span>{value}</span>
            </>
          }
        ></PriceUpDown>
      );
    }
    return {
      ...body,
      [item]: {
        children: child,
        align: align,
      },
    };
  }

export default TableBodyDataFn;
